<template>
  <form-base>
    <template v-slot:form>
      <v-form ref="form" v-on:submit.prevent @keyup.native.enter="submit">
        <p class="mb-4">
          This action will install the necessary fields and forms to enable the selected feature at
          the <strong>Warehouse Fields & Forms</strong> section.
        </p>
        <p>
          Although, the forms will be <strong>disabled</strong> after installing them, which
          requires the warehouse user to enable such feature on the
          <strong>warehouse settings</strong>.
        </p>

        <h4 class="my-6">ORG: {{ orgName }}</h4>

        <br />

        <v-select
          class="my-2"
          required
          item-text="label"
          :items="features"
          :messages="selectedFeatureDescription"
          v-model="selectedFeature"
          label="Select a feature"
          item-value="value">
        </v-select>

        <v-card elevation="1" class="my-6" v-if="selectedFeature">
          <v-list>
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-title> <strong> Warehouses feature status </strong></v-list-item-title>
                <v-list-item-action>
                  ({{ warehouseTriggers[selectedFeature]?.length }})
                </v-list-item-action>
              </template>
              <v-list-item>
                <v-row>
                  <v-col><strong>Warehouse</strong></v-col>
                  <v-col
                    class="text-center"
                    v-for="app of Object.keys(novaCore.AppsEnum)"
                    v-bind:key="app">
                    <strong>{{ app }}</strong>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item
                v-for="warehouse of warehouseTriggers[selectedFeature]"
                v-bind:key="warehouse.id">
                <v-list-item-content>
                  <v-row>
                    <v-col>
                      <strong>
                        <v-icon small class="mr-2">mdi-warehouse</v-icon>{{ warehouse.name }}
                      </strong>
                    </v-col>
                    <v-col
                      v-for="[app, triggers] of Object.entries(warehouse.triggers)"
                      v-bind:key="app"
                      class="text-center">
                      <v-chip
                        class="lighten-4"
                        small
                        label
                        :class="triggers.length > 0 ? 'completed' : 'grey'">
                        <v-icon
                          x-small
                          class="mr-2"
                          :color="triggers.length > 0 ? 'completed' : ''">
                          {{ triggers.length > 0 ? 'mdi-check' : 'mdi-table-off' }}
                        </v-icon>
                        {{ triggers.length > 0 ? 'Installed' : 'Not installed' }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-form>
    </template>
    <template v-slot:form-actions>
      <action-group
        @cancel="cancel"
        confirm-icon="update"
        confirm-label="Install feature"
        :disable-confirm="!selectedFeature"
        @confirm="submit">
      </action-group>
    </template>
  </form-base>
</template>

<script>
export default {
  props: {
    orgId: {
      type: String,
      required: true
    },
    orgName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedFeature: '',
      warehouseTriggers: {}
    };
  },
  computed: {
    features() {
      return Object.keys(this.novaCore.CustomFormsFeaturesData).map(key => key);
    },
    selectedFeatureDescription() {
      return this.novaCore.CustomFormsFeaturesData[this.selectedFeature]?.description;
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit('loading', true);
      const response = await axios.post(`/org/${this.orgId}/features/${this.selectedFeature}`);

      if (response?.data?.ok === true) {
        this.notify(`${this.selectedFeature} was installed at ${this.orgName}`, 'success');
        this.$emit('loading', false);
        this.$emit('close');
      }

      this.$emit('loading', false);
    },
    cancel() {
      this.$emit('close');
    },
    async getTriggers() {
      const response = await axios.get('/custom-forms/trigger', {
        params: {
          s: { orgId: this.orgId },
          limit: 10000
        }
      });

      return response?.data?.data || [];
    },
    async getWarehouses() {
      const response = await axios.get('/warehouse', {
        params: { s: { orgId: this.orgId }, select: ['name', 'id'], limit: 10000 }
      });

      return response?.data?.data || [];
    },
    async setWarehouseTriggers() {
      this.$emit('loading', true);

      const triggers = await this.getTriggers();
      const warehouses = await this.getWarehouses();

      this.features.forEach(feature => {
        this.warehouseTriggers[feature] = warehouses.map(warehouse => ({
          id: warehouse.id,
          name: warehouse.name,
          triggers: {}
        }));

        Object.values(this.novaCore.AppsEnum).forEach(app => {
          this.warehouseTriggers[feature].forEach(
            w =>
              (w.triggers[app] = triggers.filter(
                trigger => trigger.feature === feature && trigger.app === app
              ))
          );
        });
      });
      this.$emit('loading', false);
    }
  },
  async beforeMount() {
    await this.setWarehouseTriggers();
  }
};
</script>
